"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M4.47 19h15.06L12 5.99zM13 18h-2v-2h2zm0-4h-2v-4h2z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M1 21h22L12 2zm3.47-2L12 5.99 19.53 19zM11 16h2v2h-2zm0-6h2v4h-2z"
}, "1")], 'WarningTwoTone');